//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { getAccessTokenFromLocalStorage } from "../utilities/platform-helpers/auth-helper";
export class BaseClient {
  public async transformOptions(options: RequestInit): Promise<RequestInit> {
    const token = localStorage.getItem("token");
    const headerData = token
      ? {
          ...options.headers,
          Authorization: "Bearer " + token,
        }
      : {
          ...options.headers,
        };
    return Object.assign({}, options, {
      headers: headerData,
    });
  }
}

export class CompetitionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    postNewCompetitionCode(competition: Competition): Promise<void> {
        let url_ = this.baseUrl + "/api/Competition/PostNewCompetitionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(competition);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostNewCompetitionCode(_response);
        });
    }

    protected processPostNewCompetitionCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConsumptionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getByDate(date: Date | undefined, connectionIds: string[]): Promise<DailyConsumptionDto[]> {
        let url_ = this.baseUrl + "/api/Consumption/GetByDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(connectionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByDate(_response);
        });
    }

    protected processGetByDate(response: Response): Promise<DailyConsumptionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyConsumptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DailyConsumptionDto[]>(null as any);
    }
}

export class ConsumptionWebClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getByDateRange(fromDate: Date | undefined, toDate: Date | undefined, organizationId: number | undefined): Promise<DailyConsumptionDto[]> {
        let url_ = this.baseUrl + "/api/ConsumptionWeb/GetByDateRange?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByDateRange(_response);
        });
    }

    protected processGetByDateRange(response: Response): Promise<DailyConsumptionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyConsumptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DailyConsumptionDto[]>(null as any);
    }

    getByDate(date: Date | undefined, organizationId: number | undefined): Promise<DailyConsumptionDto[]> {
        let url_ = this.baseUrl + "/api/ConsumptionWeb/GetByDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByDate(_response);
        });
    }

    protected processGetByDate(response: Response): Promise<DailyConsumptionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyConsumptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DailyConsumptionDto[]>(null as any);
    }

    getExcelExport(data: ConsumptionExcelDataDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ConsumptionWeb/GetConsumptionExcelExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExcelExport(_response);
        });
    }

    protected processGetExcelExport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ContactClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getContacts(organizationId: number | undefined): Promise<ContactDto[]> {
        let url_ = this.baseUrl + "/api/Contact/GetContacts?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContacts(_response);
        });
    }

    protected processGetContacts(response: Response): Promise<ContactDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactDto[]>(null as any);
    }
}

export class ContractClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getContractsDetails(organizationId: number | undefined): Promise<ContractDto[]> {
        let url_ = this.baseUrl + "/api/Contract/GetContractDetails?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContractsDetails(_response);
        });
    }

    protected processGetContractsDetails(response: Response): Promise<ContractDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractDto[]>(null as any);
    }

    renewContact(organizationId: number | undefined, contract: ContractDto): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Contract/RenewContact?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRenewContact(_response);
        });
    }

    protected processRenewContact(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CustomerServiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getCustomerServiceInfo(): Promise<CustomerServiceDto> {
        let url_ = this.baseUrl + "/api/CustomerService/GetCustomerServiceInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerServiceInfo(_response);
        });
    }

    protected processGetCustomerServiceInfo(response: Response): Promise<CustomerServiceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerServiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerServiceDto>(null as any);
    }
}

export class DebtorPostingClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getDebtorPostingsDetails(organizationId: number | undefined): Promise<DebtorPostingDto[]> {
        let url_ = this.baseUrl + "/api/DebtorPosting/GetDebtorPostingsDetails?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDebtorPostingsDetails(_response);
        });
    }

    protected processGetDebtorPostingsDetails(response: Response): Promise<DebtorPostingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DebtorPostingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DebtorPostingDto[]>(null as any);
    }
}

export class DocumentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getDocumentDetails(organizationId: number | undefined): Promise<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/Document/GetDocumentDetails?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentDetails(_response);
        });
    }

    protected processGetDocumentDetails(response: Response): Promise<DocumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDto[]>(null as any);
    }

    getDebtorPostingDocumentDetails(organizationId: number | undefined): Promise<DebtorPostingDocumentDto[]> {
        let url_ = this.baseUrl + "/api/Document/GetDebtorPostingDocumentDetails?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDebtorPostingDocumentDetails(_response);
        });
    }

    protected processGetDebtorPostingDocumentDetails(response: Response): Promise<DebtorPostingDocumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DebtorPostingDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DebtorPostingDocumentDto[]>(null as any);
    }

    getDocumentAzure(documentId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/GetDocumentPDF?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentAzure(_response);
        });
    }

    protected processGetDocumentAzure(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class GreenOptimizationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getGreenOptimizationContractsStatus(organizationId: number | undefined): Promise<GreenOptimizationContractDto> {
        let url_ = this.baseUrl + "/api/GreenOptimization/GetGreenOptimizationContractsStatus?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGreenOptimizationContractsStatus(_response);
        });
    }

    protected processGetGreenOptimizationContractsStatus(response: Response): Promise<GreenOptimizationContractDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GreenOptimizationContractDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GreenOptimizationContractDto>(null as any);
    }

    chooseGreenOptimization(organizationId: number | undefined, greenOptimizationId: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/GreenOptimization/ChooseGreenOptimization?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (greenOptimizationId !== undefined && greenOptimizationId !== null)
            url_ += "greenOptimizationId=" + encodeURIComponent("" + greenOptimizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChooseGreenOptimization(_response);
        });
    }

    protected processChooseGreenOptimization(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class IntegrationConsumptionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getDailyByDateRange(fromDate: Date | null | undefined, toDate: Date | null | undefined, connectionIds: string[]): Promise<DailyConsumptionDto[]> {
        let url_ = this.baseUrl + "/api/integration/Consumption/GetDailyByDateRange?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(connectionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDailyByDateRange(_response);
        });
    }

    protected processGetDailyByDateRange(response: Response): Promise<DailyConsumptionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyConsumptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DailyConsumptionDto[]>(null as any);
    }

    getIntervalConsumptionByDateRange(fromDate: Date | null | undefined, toDate: Date | null | undefined, connectionIds: string[]): Promise<DailyConsumptionDto[]> {
        let url_ = this.baseUrl + "/api/integration/Consumption/GetIntervalConsumptionByDateRange?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(connectionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIntervalConsumptionByDateRange(_response);
        });
    }

    protected processGetIntervalConsumptionByDateRange(response: Response): Promise<DailyConsumptionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyConsumptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DailyConsumptionDto[]>(null as any);
    }
}

export class IntegrationUnitsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getUnits(): Promise<UnitDto[]> {
        let url_ = this.baseUrl + "/api/integration/Units";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnits(_response);
        });
    }

    protected processGetUnits(response: Response): Promise<UnitDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitDto[]>(null as any);
    }
}

export class MarketingMaterialsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getMarketingMaterialsByOrganizationId(organizationId: number | undefined): Promise<MarketingMaterialDto[]> {
        let url_ = this.baseUrl + "/api/MarketingMaterials?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketingMaterialsByOrganizationId(_response);
        });
    }

    protected processGetMarketingMaterialsByOrganizationId(response: Response): Promise<MarketingMaterialDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingMaterialDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingMaterialDto[]>(null as any);
    }

    getOrganizationMaterialsIdByOrganizationId(organizationId: number | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/MarketingMaterials/id?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrganizationMaterialsIdByOrganizationId(_response);
        });
    }

    protected processGetOrganizationMaterialsIdByOrganizationId(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getMarketingMaterialsByIds(marketingMaterialIds: number[], organizationId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/MarketingMaterials/GetMarketingMaterialsByIds?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingMaterialIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketingMaterialsByIds(_response);
        });
    }

    protected processGetMarketingMaterialsByIds(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    sendUpdatedMarketingMaterialNotifications(): Promise<number> {
        let url_ = this.baseUrl + "/api/MarketingMaterials/SendUpdatedMarketingMaterialNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendUpdatedMarketingMaterialNotifications(_response);
        });
    }

    protected processSendUpdatedMarketingMaterialNotifications(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class NewsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getNews(): Promise<News[]> {
        let url_ = this.baseUrl + "/api/News";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNews(_response);
        });
    }

    protected processGetNews(response: Response): Promise<News[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(News.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<News[]>(null as any);
    }

    getSingleBlog(blog: string | null | undefined): Promise<News> {
        let url_ = this.baseUrl + "/api/News/GetSingleBlog?";
        if (blog !== undefined && blog !== null)
            url_ += "blog=" + encodeURIComponent("" + blog) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSingleBlog(_response);
        });
    }

    protected processGetSingleBlog(response: Response): Promise<News> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = News.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<News>(null as any);
    }
}

export class OrganizationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getOrganizationDetails(accountNum: string | null | undefined): Promise<OrganizationDto[]> {
        let url_ = this.baseUrl + "/api/Organization/GetOrganizationDetails?";
        if (accountNum !== undefined && accountNum !== null)
            url_ += "accountNum=" + encodeURIComponent("" + accountNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrganizationDetails(_response);
        });
    }

    protected processGetOrganizationDetails(response: Response): Promise<OrganizationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDto[]>(null as any);
    }

    getOrganizationsByAuthId(): Promise<OrganizationDto[]> {
        let url_ = this.baseUrl + "/api/Organization/GetOrganizationsByAuthId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrganizationsByAuthId(_response);
        });
    }

    protected processGetOrganizationsByAuthId(response: Response): Promise<OrganizationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDto[]>(null as any);
    }

    deleteUserOrganization(userId: number | undefined, organizationId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Organization/DeleteUserOrganization?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserOrganization(_response);
        });
    }

    protected processDeleteUserOrganization(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class StatusMessageClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getStatusMessages(): Promise<StatusMessageDto[]> {
        let url_ = this.baseUrl + "/api/StatusMessage/GetStatusMessages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStatusMessages(_response);
        });
    }

    protected processGetStatusMessages(response: Response): Promise<StatusMessageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusMessageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusMessageDto[]>(null as any);
    }

    postNewStatusMessages(statusMessageDto: StatusMessageDto): Promise<StatusMessageDto> {
        let url_ = this.baseUrl + "/api/StatusMessage/PostNewStatusMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statusMessageDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostNewStatusMessages(_response);
        });
    }

    protected processPostNewStatusMessages(response: Response): Promise<StatusMessageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusMessageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusMessageDto>(null as any);
    }

    deleteStatusMessages(statusMessageId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StatusMessage/DeleteStatusMessages?";
        if (statusMessageId === null)
            throw new Error("The parameter 'statusMessageId' cannot be null.");
        else if (statusMessageId !== undefined)
            url_ += "statusMessageId=" + encodeURIComponent("" + statusMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteStatusMessages(_response);
        });
    }

    protected processDeleteStatusMessages(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UnitsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getUnitsByOrganizationId(organizationId: number | undefined): Promise<UnitDto[]> {
        let url_ = this.baseUrl + "/api/Units/GetUnitsByOrganizationId?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitsByOrganizationId(_response);
        });
    }

    protected processGetUnitsByOrganizationId(response: Response): Promise<UnitDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitDto[]>(null as any);
    }
}

export class UserClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    get(): Promise<User[]> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(null as any);
    }

    post(user: User): Promise<User> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    put(user: User): Promise<User> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    delete(user: User): Promise<void> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getById(id: number | undefined): Promise<User> {
        let url_ = this.baseUrl + "/api/User/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    getByAuthId(): Promise<User> {
        let url_ = this.baseUrl + "/api/User/GetByAuthId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByAuthId(_response);
        });
    }

    protected processGetByAuthId(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    getUsersByOrganizationId(organizationId: number | undefined): Promise<User[]> {
        let url_ = this.baseUrl + "/api/User/GetUsersByOrganizationId?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersByOrganizationId(_response);
        });
    }

    protected processGetUsersByOrganizationId(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(null as any);
    }

    resendInvitationEmail(user: User): Promise<void> {
        let url_ = this.baseUrl + "/api/User/ResendInvitationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendInvitationEmail(_response);
        });
    }

    protected processResendInvitationEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createUserWithOrganizationId(user: User, organizationId: number | undefined): Promise<User> {
        let url_ = this.baseUrl + "/api/User/CreateUserWithOrganizationId?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUserWithOrganizationId(_response);
        });
    }

    protected processCreateUserWithOrganizationId(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    signUp(userDto: WebHookUserDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/User/SignUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignUp(_response);
        });
    }

    protected processSignUp(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getUserInfo(userDto: WebHookUserDTO): Promise<WebHookUserDTO> {
        let url_ = this.baseUrl + "/api/User/GetUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: Response): Promise<WebHookUserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebHookUserDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebHookUserDTO>(null as any);
    }

    checkUserInvites(): Promise<void> {
        let url_ = this.baseUrl + "/api/User/CheckUserInvites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckUserInvites(_response);
        });
    }

    protected processCheckUserInvites(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateLastOpenedMarketingPage(organizationId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/User/UpdateLastOpenedMarketingPage?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLastOpenedMarketingPage(_response);
        });
    }

    protected processUpdateLastOpenedMarketingPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export abstract class ModelBase implements IModelBase {
    id!: number;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    isDeleted!: boolean;

    constructor(data?: IModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ModelBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ModelBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IModelBase {
    id: number;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    isDeleted: boolean;
}

export class Competition extends ModelBase implements ICompetition {
    code?: string | undefined;
    mail?: string | undefined;
    userId!: number;
    organizationId!: number;

    constructor(data?: ICompetition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.mail = _data["mail"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): Competition {
        data = typeof data === 'object' ? data : {};
        let result = new Competition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["mail"] = this.mail;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface ICompetition extends IModelBase {
    code?: string | undefined;
    mail?: string | undefined;
    userId: number;
    organizationId: number;
}

export class DailyConsumptionDto implements IDailyConsumptionDto {
    consumptionValue!: number;
    connectionId?: string | undefined;
    date!: Date;

    constructor(data?: IDailyConsumptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumptionValue = _data["consumptionValue"];
            this.connectionId = _data["connectionId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DailyConsumptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyConsumptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumptionValue"] = this.consumptionValue;
        data["connectionId"] = this.connectionId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDailyConsumptionDto {
    consumptionValue: number;
    connectionId?: string | undefined;
    date: Date;
}

export class ConsumptionExcelDataDto implements IConsumptionExcelDataDto {
    excelData?: ConsumptionExcelData[] | undefined;
    headers?: string[] | undefined;
    worksheetName?: string | undefined;

    constructor(data?: IConsumptionExcelDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["excelData"])) {
                this.excelData = [] as any;
                for (let item of _data["excelData"])
                    this.excelData!.push(ConsumptionExcelData.fromJS(item));
            }
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(item);
            }
            this.worksheetName = _data["worksheetName"];
        }
    }

    static fromJS(data: any): ConsumptionExcelDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionExcelDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.excelData)) {
            data["excelData"] = [];
            for (let item of this.excelData)
                data["excelData"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item);
        }
        data["worksheetName"] = this.worksheetName;
        return data;
    }
}

export interface IConsumptionExcelDataDto {
    excelData?: ConsumptionExcelData[] | undefined;
    headers?: string[] | undefined;
    worksheetName?: string | undefined;
}

export class ConsumptionExcelData implements IConsumptionExcelData {
    date?: string | undefined;
    usage!: number;
    eanNumber?: string | undefined;
    measuringPoint?: string | undefined;

    constructor(data?: IConsumptionExcelData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.usage = _data["usage"];
            this.eanNumber = _data["eanNumber"];
            this.measuringPoint = _data["measuringPoint"];
        }
    }

    static fromJS(data: any): ConsumptionExcelData {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionExcelData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["usage"] = this.usage;
        data["eanNumber"] = this.eanNumber;
        data["measuringPoint"] = this.measuringPoint;
        return data;
    }
}

export interface IConsumptionExcelData {
    date?: string | undefined;
    usage: number;
    eanNumber?: string | undefined;
    measuringPoint?: string | undefined;
}

export class ContactDto implements IContactDto {
    contactTitle?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    image?: string | undefined;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactTitle = _data["contactTitle"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactTitle"] = this.contactTitle;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["image"] = this.image;
        return data;
    }
}

export interface IContactDto {
    contactTitle?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    image?: string | undefined;
}

export class ContractDto implements IContractDto {
    documentId!: number;
    document?: Document | undefined;
    productCategory!: ProductCategory;
    productSubcategory!: ProductSubcategory;
    contractStart!: Date;
    contractEnd!: Date;
    priceDistrict?: string | undefined;
    premium?: string | undefined;
    price?: number | undefined;
    fixedPricePremium?: number | undefined;
    active!: boolean;
    originalCeilingYear1?: number | undefined;
    originalCeilingYear2?: number | undefined;
    originalCeilingYear3?: number | undefined;
    originalCeilingYear4?: number | undefined;
    originalCeilingYear5?: number | undefined;
    originalCeilingYear6?: number | undefined;
    currentCeilingYear1?: number | undefined;
    currentCeilingYear2?: number | undefined;
    currentCeilingYear3?: number | undefined;
    currentCeilingYear4?: number | undefined;
    currentCeilingYear5?: number | undefined;
    currentCeilingYear6?: number | undefined;
    supplement?: number | undefined;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.productCategory = _data["productCategory"];
            this.productSubcategory = _data["productSubcategory"];
            this.contractStart = _data["contractStart"] ? new Date(_data["contractStart"].toString()) : <any>undefined;
            this.contractEnd = _data["contractEnd"] ? new Date(_data["contractEnd"].toString()) : <any>undefined;
            this.priceDistrict = _data["priceDistrict"];
            this.premium = _data["premium"];
            this.price = _data["price"];
            this.fixedPricePremium = _data["fixedPricePremium"];
            this.active = _data["active"];
            this.originalCeilingYear1 = _data["originalCeilingYear1"];
            this.originalCeilingYear2 = _data["originalCeilingYear2"];
            this.originalCeilingYear3 = _data["originalCeilingYear3"];
            this.originalCeilingYear4 = _data["originalCeilingYear4"];
            this.originalCeilingYear5 = _data["originalCeilingYear5"];
            this.originalCeilingYear6 = _data["originalCeilingYear6"];
            this.currentCeilingYear1 = _data["currentCeilingYear1"];
            this.currentCeilingYear2 = _data["currentCeilingYear2"];
            this.currentCeilingYear3 = _data["currentCeilingYear3"];
            this.currentCeilingYear4 = _data["currentCeilingYear4"];
            this.currentCeilingYear5 = _data["currentCeilingYear5"];
            this.currentCeilingYear6 = _data["currentCeilingYear6"];
            this.supplement = _data["supplement"];
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["productCategory"] = this.productCategory;
        data["productSubcategory"] = this.productSubcategory;
        data["contractStart"] = this.contractStart ? this.contractStart.toISOString() : <any>undefined;
        data["contractEnd"] = this.contractEnd ? this.contractEnd.toISOString() : <any>undefined;
        data["priceDistrict"] = this.priceDistrict;
        data["premium"] = this.premium;
        data["price"] = this.price;
        data["fixedPricePremium"] = this.fixedPricePremium;
        data["active"] = this.active;
        data["originalCeilingYear1"] = this.originalCeilingYear1;
        data["originalCeilingYear2"] = this.originalCeilingYear2;
        data["originalCeilingYear3"] = this.originalCeilingYear3;
        data["originalCeilingYear4"] = this.originalCeilingYear4;
        data["originalCeilingYear5"] = this.originalCeilingYear5;
        data["originalCeilingYear6"] = this.originalCeilingYear6;
        data["currentCeilingYear1"] = this.currentCeilingYear1;
        data["currentCeilingYear2"] = this.currentCeilingYear2;
        data["currentCeilingYear3"] = this.currentCeilingYear3;
        data["currentCeilingYear4"] = this.currentCeilingYear4;
        data["currentCeilingYear5"] = this.currentCeilingYear5;
        data["currentCeilingYear6"] = this.currentCeilingYear6;
        data["supplement"] = this.supplement;
        return data;
    }
}

export interface IContractDto {
    documentId: number;
    document?: Document | undefined;
    productCategory: ProductCategory;
    productSubcategory: ProductSubcategory;
    contractStart: Date;
    contractEnd: Date;
    priceDistrict?: string | undefined;
    premium?: string | undefined;
    price?: number | undefined;
    fixedPricePremium?: number | undefined;
    active: boolean;
    originalCeilingYear1?: number | undefined;
    originalCeilingYear2?: number | undefined;
    originalCeilingYear3?: number | undefined;
    originalCeilingYear4?: number | undefined;
    originalCeilingYear5?: number | undefined;
    originalCeilingYear6?: number | undefined;
    currentCeilingYear1?: number | undefined;
    currentCeilingYear2?: number | undefined;
    currentCeilingYear3?: number | undefined;
    currentCeilingYear4?: number | undefined;
    currentCeilingYear5?: number | undefined;
    currentCeilingYear6?: number | undefined;
    supplement?: number | undefined;
}

export class Document extends ModelBase implements IDocument {
    name?: string | undefined;
    documentType!: DocumentType;
    date!: Date;
    organization?: Organization | undefined;
    organizationId!: number;
    filePath?: string | undefined;
    fileName?: string | undefined;
    debtorPosting?: DebtorPosting | undefined;

    constructor(data?: IDocument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.documentType = _data["documentType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.organizationId = _data["organizationId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.debtorPosting = _data["debtorPosting"] ? DebtorPosting.fromJS(_data["debtorPosting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["documentType"] = this.documentType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["organizationId"] = this.organizationId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["debtorPosting"] = this.debtorPosting ? this.debtorPosting.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDocument extends IModelBase {
    name?: string | undefined;
    documentType: DocumentType;
    date: Date;
    organization?: Organization | undefined;
    organizationId: number;
    filePath?: string | undefined;
    fileName?: string | undefined;
    debtorPosting?: DebtorPosting | undefined;
}

export enum DocumentType {
    Contract = 0,
    GreenOptimizationContract = 1,
    GreenOptimizationReports = 2,
    Invoice = 3,
    BasicReports = 4,
    AnnualStatement = 5,
}

export class Organization extends ModelBase implements IOrganization {
    accountNum?: string | undefined;
    accountName?: string | undefined;
    street?: string | undefined;
    houseNum?: string | undefined;
    zipcode?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    fax?: string | undefined;
    cvr?: string | undefined;
    homepage?: string | undefined;
    accountConnections?: AccountConnection[] | undefined;
    contracts?: Contract[] | undefined;
    documents?: Document[] | undefined;
    debtorPostings?: DebtorPosting[] | undefined;
    greenOptimizationContracts?: GreenOptimizationContract[] | undefined;
    organizationsContacts?: OrganizationsContact[] | undefined;
    organizationsUsers?: OrganizationsUser[] | undefined;

    constructor(data?: IOrganization) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountNum = _data["accountNum"];
            this.accountName = _data["accountName"];
            this.street = _data["street"];
            this.houseNum = _data["houseNum"];
            this.zipcode = _data["zipcode"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.fax = _data["fax"];
            this.cvr = _data["cvr"];
            this.homepage = _data["homepage"];
            if (Array.isArray(_data["accountConnections"])) {
                this.accountConnections = [] as any;
                for (let item of _data["accountConnections"])
                    this.accountConnections!.push(AccountConnection.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(Contract.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["debtorPostings"])) {
                this.debtorPostings = [] as any;
                for (let item of _data["debtorPostings"])
                    this.debtorPostings!.push(DebtorPosting.fromJS(item));
            }
            if (Array.isArray(_data["greenOptimizationContracts"])) {
                this.greenOptimizationContracts = [] as any;
                for (let item of _data["greenOptimizationContracts"])
                    this.greenOptimizationContracts!.push(GreenOptimizationContract.fromJS(item));
            }
            if (Array.isArray(_data["organizationsContacts"])) {
                this.organizationsContacts = [] as any;
                for (let item of _data["organizationsContacts"])
                    this.organizationsContacts!.push(OrganizationsContact.fromJS(item));
            }
            if (Array.isArray(_data["organizationsUsers"])) {
                this.organizationsUsers = [] as any;
                for (let item of _data["organizationsUsers"])
                    this.organizationsUsers!.push(OrganizationsUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNum"] = this.accountNum;
        data["accountName"] = this.accountName;
        data["street"] = this.street;
        data["houseNum"] = this.houseNum;
        data["zipcode"] = this.zipcode;
        data["city"] = this.city;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["fax"] = this.fax;
        data["cvr"] = this.cvr;
        data["homepage"] = this.homepage;
        if (Array.isArray(this.accountConnections)) {
            data["accountConnections"] = [];
            for (let item of this.accountConnections)
                data["accountConnections"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.debtorPostings)) {
            data["debtorPostings"] = [];
            for (let item of this.debtorPostings)
                data["debtorPostings"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.greenOptimizationContracts)) {
            data["greenOptimizationContracts"] = [];
            for (let item of this.greenOptimizationContracts)
                data["greenOptimizationContracts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.organizationsContacts)) {
            data["organizationsContacts"] = [];
            for (let item of this.organizationsContacts)
                data["organizationsContacts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.organizationsUsers)) {
            data["organizationsUsers"] = [];
            for (let item of this.organizationsUsers)
                data["organizationsUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOrganization extends IModelBase {
    accountNum?: string | undefined;
    accountName?: string | undefined;
    street?: string | undefined;
    houseNum?: string | undefined;
    zipcode?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    fax?: string | undefined;
    cvr?: string | undefined;
    homepage?: string | undefined;
    accountConnections?: AccountConnection[] | undefined;
    contracts?: Contract[] | undefined;
    documents?: Document[] | undefined;
    debtorPostings?: DebtorPosting[] | undefined;
    greenOptimizationContracts?: GreenOptimizationContract[] | undefined;
    organizationsContacts?: OrganizationsContact[] | undefined;
    organizationsUsers?: OrganizationsUser[] | undefined;
}

export abstract class ModelBaseNoId implements IModelBaseNoId {
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    isDeleted!: boolean;

    constructor(data?: IModelBaseNoId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ModelBaseNoId {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ModelBaseNoId' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IModelBaseNoId {
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    isDeleted: boolean;
}

export class AccountConnection extends ModelBaseNoId implements IAccountConnection {
    dwId!: number;
    accountNum?: string | undefined;
    accountName?: string | undefined;
    connectionid?: string | undefined;
    eanid?: string | undefined;
    street?: string | undefined;
    houseNum?: string | undefined;
    zipcode?: string | undefined;
    city?: string | undefined;
    organization?: Organization | undefined;
    organizationId?: number | undefined;
    contractStartDate!: Date;
    contractEndDate!: Date;

    constructor(data?: IAccountConnection) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dwId = _data["dwId"];
            this.accountNum = _data["accountNum"];
            this.accountName = _data["accountName"];
            this.connectionid = _data["connectionid"];
            this.eanid = _data["eanid"];
            this.street = _data["street"];
            this.houseNum = _data["houseNum"];
            this.zipcode = _data["zipcode"];
            this.city = _data["city"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.organizationId = _data["organizationId"];
            this.contractStartDate = _data["contractStartDate"] ? new Date(_data["contractStartDate"].toString()) : <any>undefined;
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountConnection {
        data = typeof data === 'object' ? data : {};
        let result = new AccountConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dwId"] = this.dwId;
        data["accountNum"] = this.accountNum;
        data["accountName"] = this.accountName;
        data["connectionid"] = this.connectionid;
        data["eanid"] = this.eanid;
        data["street"] = this.street;
        data["houseNum"] = this.houseNum;
        data["zipcode"] = this.zipcode;
        data["city"] = this.city;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["organizationId"] = this.organizationId;
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toISOString() : <any>undefined;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAccountConnection extends IModelBaseNoId {
    dwId: number;
    accountNum?: string | undefined;
    accountName?: string | undefined;
    connectionid?: string | undefined;
    eanid?: string | undefined;
    street?: string | undefined;
    houseNum?: string | undefined;
    zipcode?: string | undefined;
    city?: string | undefined;
    organization?: Organization | undefined;
    organizationId?: number | undefined;
    contractStartDate: Date;
    contractEndDate: Date;
}

export class Contract extends ModelBase implements IContract {
    productCategory!: ProductCategory;
    productSubcategory!: ProductSubcategory;
    contractStart!: Date;
    contractEnd!: Date;
    priceDistrict?: string | undefined;
    premium?: string | undefined;
    price?: number | undefined;
    fixedPricePremium?: number | undefined;
    active!: boolean;
    document?: Document | undefined;
    documentId!: number;
    organization?: Organization | undefined;
    organizationId!: number;
    originalCeilingYear1?: number | undefined;
    originalCeilingYear2?: number | undefined;
    originalCeilingYear3?: number | undefined;
    originalCeilingYear4?: number | undefined;
    originalCeilingYear5?: number | undefined;
    originalCeilingYear6?: number | undefined;
    currentCeilingYear1?: number | undefined;
    currentCeilingYear2?: number | undefined;
    currentCeilingYear3?: number | undefined;
    currentCeilingYear4?: number | undefined;
    currentCeilingYear5?: number | undefined;
    currentCeilingYear6?: number | undefined;
    supplement?: number | undefined;

    constructor(data?: IContract) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCategory = _data["productCategory"];
            this.productSubcategory = _data["productSubcategory"];
            this.contractStart = _data["contractStart"] ? new Date(_data["contractStart"].toString()) : <any>undefined;
            this.contractEnd = _data["contractEnd"] ? new Date(_data["contractEnd"].toString()) : <any>undefined;
            this.priceDistrict = _data["priceDistrict"];
            this.premium = _data["premium"];
            this.price = _data["price"];
            this.fixedPricePremium = _data["fixedPricePremium"];
            this.active = _data["active"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.organizationId = _data["organizationId"];
            this.originalCeilingYear1 = _data["originalCeilingYear1"];
            this.originalCeilingYear2 = _data["originalCeilingYear2"];
            this.originalCeilingYear3 = _data["originalCeilingYear3"];
            this.originalCeilingYear4 = _data["originalCeilingYear4"];
            this.originalCeilingYear5 = _data["originalCeilingYear5"];
            this.originalCeilingYear6 = _data["originalCeilingYear6"];
            this.currentCeilingYear1 = _data["currentCeilingYear1"];
            this.currentCeilingYear2 = _data["currentCeilingYear2"];
            this.currentCeilingYear3 = _data["currentCeilingYear3"];
            this.currentCeilingYear4 = _data["currentCeilingYear4"];
            this.currentCeilingYear5 = _data["currentCeilingYear5"];
            this.currentCeilingYear6 = _data["currentCeilingYear6"];
            this.supplement = _data["supplement"];
        }
    }

    static fromJS(data: any): Contract {
        data = typeof data === 'object' ? data : {};
        let result = new Contract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory;
        data["productSubcategory"] = this.productSubcategory;
        data["contractStart"] = this.contractStart ? this.contractStart.toISOString() : <any>undefined;
        data["contractEnd"] = this.contractEnd ? this.contractEnd.toISOString() : <any>undefined;
        data["priceDistrict"] = this.priceDistrict;
        data["premium"] = this.premium;
        data["price"] = this.price;
        data["fixedPricePremium"] = this.fixedPricePremium;
        data["active"] = this.active;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["organizationId"] = this.organizationId;
        data["originalCeilingYear1"] = this.originalCeilingYear1;
        data["originalCeilingYear2"] = this.originalCeilingYear2;
        data["originalCeilingYear3"] = this.originalCeilingYear3;
        data["originalCeilingYear4"] = this.originalCeilingYear4;
        data["originalCeilingYear5"] = this.originalCeilingYear5;
        data["originalCeilingYear6"] = this.originalCeilingYear6;
        data["currentCeilingYear1"] = this.currentCeilingYear1;
        data["currentCeilingYear2"] = this.currentCeilingYear2;
        data["currentCeilingYear3"] = this.currentCeilingYear3;
        data["currentCeilingYear4"] = this.currentCeilingYear4;
        data["currentCeilingYear5"] = this.currentCeilingYear5;
        data["currentCeilingYear6"] = this.currentCeilingYear6;
        data["supplement"] = this.supplement;
        super.toJSON(data);
        return data;
    }
}

export interface IContract extends IModelBase {
    productCategory: ProductCategory;
    productSubcategory: ProductSubcategory;
    contractStart: Date;
    contractEnd: Date;
    priceDistrict?: string | undefined;
    premium?: string | undefined;
    price?: number | undefined;
    fixedPricePremium?: number | undefined;
    active: boolean;
    document?: Document | undefined;
    documentId: number;
    organization?: Organization | undefined;
    organizationId: number;
    originalCeilingYear1?: number | undefined;
    originalCeilingYear2?: number | undefined;
    originalCeilingYear3?: number | undefined;
    originalCeilingYear4?: number | undefined;
    originalCeilingYear5?: number | undefined;
    originalCeilingYear6?: number | undefined;
    currentCeilingYear1?: number | undefined;
    currentCeilingYear2?: number | undefined;
    currentCeilingYear3?: number | undefined;
    currentCeilingYear4?: number | undefined;
    currentCeilingYear5?: number | undefined;
    currentCeilingYear6?: number | undefined;
    supplement?: number | undefined;
}

export enum ProductCategory {
    ElectricitySales = 0,
    GreenEnergy = 1,
    Counseling = 2,
}

export enum ProductSubcategory {
    Spottime = 0,
    SMO = 1,
    FASTfast = 2,
    FASTfastUp = 3,
    FASTloft = 4,
    FLEXloft = 5,
    FLEXfast = 6,
    FLEXvalg = 7,
    NONstop = 8,
    VINDenergy = 9,
    ClimateAction = 10,
    FASTfastSPOTtime = 11,
    FASTfastExclProfilSPOTtime = 12,
    FLEXloftSPOTtime = 13,
    CO2Mapping = 14,
    EnergyCalculation = 15,
    EnergyLabeling = 16,
    EnergySparring = 17,
    EnergySupervision = 18,
    OmegaEMS = 19,
    PriorityList = 20,
    RealizationHelp = 21,
    RealizationStart = 22,
    SubsidiesCase = 23,
    HourCase = 24,
    FLEXfastExclProfile = 25,
    FLEXfastExclProfilSPOTtime = 26,
    ClimateForest = 27,
    SolarCell = 28,
    SubsidiesHelp = 29,
    SpottimeNonStopWithWindPower = 30,
    EnergyCheck = 31,
    EsgReport = 32,
    PriceAlert = 33,
    FLEXfastFLEXSpot = 34,
    TariffCheck = 35,
    NewProduct = 255,
}

export class DebtorPosting extends ModelBase implements IDebtorPosting {
    document?: Document | undefined;
    documentId?: number | undefined;
    debtorPostingType?: DebtorPostingType | undefined;
    invoiceNumber?: string | undefined;
    description?: string | undefined;
    date!: Date;
    dueDate?: Date | undefined;
    currency?: string | undefined;
    debet?: number | undefined;
    credit?: number | undefined;
    balance!: number;
    organization?: Organization | undefined;
    organizationId!: number;
    source_Key!: number;

    constructor(data?: IDebtorPosting) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            this.debtorPostingType = _data["debtorPostingType"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.description = _data["description"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.debet = _data["debet"];
            this.credit = _data["credit"];
            this.balance = _data["balance"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.organizationId = _data["organizationId"];
            this.source_Key = _data["source_Key"];
        }
    }

    static fromJS(data: any): DebtorPosting {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorPosting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["debtorPostingType"] = this.debtorPostingType;
        data["invoiceNumber"] = this.invoiceNumber;
        data["description"] = this.description;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["debet"] = this.debet;
        data["credit"] = this.credit;
        data["balance"] = this.balance;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["organizationId"] = this.organizationId;
        data["source_Key"] = this.source_Key;
        super.toJSON(data);
        return data;
    }
}

export interface IDebtorPosting extends IModelBase {
    document?: Document | undefined;
    documentId?: number | undefined;
    debtorPostingType?: DebtorPostingType | undefined;
    invoiceNumber?: string | undefined;
    description?: string | undefined;
    date: Date;
    dueDate?: Date | undefined;
    currency?: string | undefined;
    debet?: number | undefined;
    credit?: number | undefined;
    balance: number;
    organization?: Organization | undefined;
    organizationId: number;
    source_Key: number;
}

export enum DebtorPostingType {
    Invoice = 0,
    Credit = 1,
    Other = 2,
}

export class GreenOptimizationContract extends ModelBase implements IGreenOptimizationContract {
    windEnergy?: boolean | undefined;
    climateEnergy?: boolean | undefined;
    co2Mapping?: boolean | undefined;
    energyAdvice?: boolean | undefined;
    climateForest?: boolean | undefined;
    organization?: Organization | undefined;
    organizationId!: number;

    constructor(data?: IGreenOptimizationContract) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.windEnergy = _data["windEnergy"];
            this.climateEnergy = _data["climateEnergy"];
            this.co2Mapping = _data["co2Mapping"];
            this.energyAdvice = _data["energyAdvice"];
            this.climateForest = _data["climateForest"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): GreenOptimizationContract {
        data = typeof data === 'object' ? data : {};
        let result = new GreenOptimizationContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["windEnergy"] = this.windEnergy;
        data["climateEnergy"] = this.climateEnergy;
        data["co2Mapping"] = this.co2Mapping;
        data["energyAdvice"] = this.energyAdvice;
        data["climateForest"] = this.climateForest;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["organizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }
}

export interface IGreenOptimizationContract extends IModelBase {
    windEnergy?: boolean | undefined;
    climateEnergy?: boolean | undefined;
    co2Mapping?: boolean | undefined;
    energyAdvice?: boolean | undefined;
    climateForest?: boolean | undefined;
    organization?: Organization | undefined;
    organizationId: number;
}

export class OrganizationsContact implements IOrganizationsContact {
    organization?: Organization | undefined;
    organizationId!: number;
    contact?: Contact | undefined;
    contactId!: number;

    constructor(data?: IOrganizationsContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.organizationId = _data["organizationId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.contactId = _data["contactId"];
        }
    }

    static fromJS(data: any): OrganizationsContact {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationsContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["organizationId"] = this.organizationId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        return data;
    }
}

export interface IOrganizationsContact {
    organization?: Organization | undefined;
    organizationId: number;
    contact?: Contact | undefined;
    contactId: number;
}

export class Contact extends ModelBase implements IContact {
    contactTitle?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    filePath?: string | undefined;
    fileName?: string | undefined;
    organizationsContacts?: OrganizationsContact[] | undefined;

    constructor(data?: IContact) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactTitle = _data["contactTitle"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["organizationsContacts"])) {
                this.organizationsContacts = [] as any;
                for (let item of _data["organizationsContacts"])
                    this.organizationsContacts!.push(OrganizationsContact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactTitle"] = this.contactTitle;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        if (Array.isArray(this.organizationsContacts)) {
            data["organizationsContacts"] = [];
            for (let item of this.organizationsContacts)
                data["organizationsContacts"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IContact extends IModelBase {
    contactTitle?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    filePath?: string | undefined;
    fileName?: string | undefined;
    organizationsContacts?: OrganizationsContact[] | undefined;
}

export class OrganizationsUser implements IOrganizationsUser {
    organization?: Organization | undefined;
    organizationId!: number;
    user?: User | undefined;
    userId!: number;
    lastVisitedMarketingPage!: Date;

    constructor(data?: IOrganizationsUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.organizationId = _data["organizationId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.lastVisitedMarketingPage = _data["lastVisitedMarketingPage"] ? new Date(_data["lastVisitedMarketingPage"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationsUser {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationsUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["organizationId"] = this.organizationId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["lastVisitedMarketingPage"] = this.lastVisitedMarketingPage ? this.lastVisitedMarketingPage.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrganizationsUser {
    organization?: Organization | undefined;
    organizationId: number;
    user?: User | undefined;
    userId: number;
    lastVisitedMarketingPage: Date;
}

export class User extends ModelBase implements IUser {
    authId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phonenumber?: string | undefined;
    title?: string | undefined;
    role!: UserRole;
    inviteSent?: Date | undefined;
    inviteAccepted?: Date | undefined;
    organizationsUsers?: OrganizationsUser[] | undefined;

    constructor(data?: IUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phonenumber = _data["phonenumber"];
            this.title = _data["title"];
            this.role = _data["role"];
            this.inviteSent = _data["inviteSent"] ? new Date(_data["inviteSent"].toString()) : <any>undefined;
            this.inviteAccepted = _data["inviteAccepted"] ? new Date(_data["inviteAccepted"].toString()) : <any>undefined;
            if (Array.isArray(_data["organizationsUsers"])) {
                this.organizationsUsers = [] as any;
                for (let item of _data["organizationsUsers"])
                    this.organizationsUsers!.push(OrganizationsUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phonenumber"] = this.phonenumber;
        data["title"] = this.title;
        data["role"] = this.role;
        data["inviteSent"] = this.inviteSent ? this.inviteSent.toISOString() : <any>undefined;
        data["inviteAccepted"] = this.inviteAccepted ? this.inviteAccepted.toISOString() : <any>undefined;
        if (Array.isArray(this.organizationsUsers)) {
            data["organizationsUsers"] = [];
            for (let item of this.organizationsUsers)
                data["organizationsUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUser extends IModelBase {
    authId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phonenumber?: string | undefined;
    title?: string | undefined;
    role: UserRole;
    inviteSent?: Date | undefined;
    inviteAccepted?: Date | undefined;
    organizationsUsers?: OrganizationsUser[] | undefined;
}

export enum UserRole {
    User = 0,
    Admin = 1,
}

export class CustomerServiceDto implements ICustomerServiceDto {
    mondayToThursday?: string | undefined;
    friday?: string | undefined;
    nextInvoice!: Date;
    loginPageText?: string | undefined;
    showLoginPageText!: boolean;

    constructor(data?: ICustomerServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mondayToThursday = _data["mondayToThursday"];
            this.friday = _data["friday"];
            this.nextInvoice = _data["nextInvoice"] ? new Date(_data["nextInvoice"].toString()) : <any>undefined;
            this.loginPageText = _data["loginPageText"];
            this.showLoginPageText = _data["showLoginPageText"];
        }
    }

    static fromJS(data: any): CustomerServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mondayToThursday"] = this.mondayToThursday;
        data["friday"] = this.friday;
        data["nextInvoice"] = this.nextInvoice ? this.nextInvoice.toISOString() : <any>undefined;
        data["loginPageText"] = this.loginPageText;
        data["showLoginPageText"] = this.showLoginPageText;
        return data;
    }
}

export interface ICustomerServiceDto {
    mondayToThursday?: string | undefined;
    friday?: string | undefined;
    nextInvoice: Date;
    loginPageText?: string | undefined;
    showLoginPageText: boolean;
}

export class DebtorPostingDto implements IDebtorPostingDto {
    invoiceNumber?: string | undefined;
    description?: string | undefined;
    date!: Date;
    dueDate?: Date | undefined;
    currency?: string | undefined;
    debet?: number | undefined;
    credit?: number | undefined;
    balance!: number;
    debtorPostingType?: DebtorPostingType | undefined;
    document?: Document | undefined;
    documentId!: number;

    constructor(data?: IDebtorPostingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.description = _data["description"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.debet = _data["debet"];
            this.credit = _data["credit"];
            this.balance = _data["balance"];
            this.debtorPostingType = _data["debtorPostingType"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): DebtorPostingDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorPostingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["description"] = this.description;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["debet"] = this.debet;
        data["credit"] = this.credit;
        data["balance"] = this.balance;
        data["debtorPostingType"] = this.debtorPostingType;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IDebtorPostingDto {
    invoiceNumber?: string | undefined;
    description?: string | undefined;
    date: Date;
    dueDate?: Date | undefined;
    currency?: string | undefined;
    debet?: number | undefined;
    credit?: number | undefined;
    balance: number;
    debtorPostingType?: DebtorPostingType | undefined;
    document?: Document | undefined;
    documentId: number;
}

export class DocumentDto implements IDocumentDto {
    id!: number;
    name?: string | undefined;
    documentType!: DocumentType;
    date!: Date;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.documentType = _data["documentType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["documentType"] = this.documentType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentDto {
    id: number;
    name?: string | undefined;
    documentType: DocumentType;
    date: Date;
}

export class DebtorPostingDocumentDto implements IDebtorPostingDocumentDto {
    id!: number;
    name?: string | undefined;
    documentType!: DocumentType;
    date!: Date;
    debtorPostingType?: DebtorPostingType | undefined;
    amount?: number | undefined;
    invoiceNumber?: string | undefined;

    constructor(data?: IDebtorPostingDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.documentType = _data["documentType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.debtorPostingType = _data["debtorPostingType"];
            this.amount = _data["amount"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): DebtorPostingDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorPostingDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["documentType"] = this.documentType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["debtorPostingType"] = this.debtorPostingType;
        data["amount"] = this.amount;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IDebtorPostingDocumentDto {
    id: number;
    name?: string | undefined;
    documentType: DocumentType;
    date: Date;
    debtorPostingType?: DebtorPostingType | undefined;
    amount?: number | undefined;
    invoiceNumber?: string | undefined;
}

export class GreenOptimizationContractDto extends ModelBase implements IGreenOptimizationContractDto {
    windEnergy?: boolean | undefined;
    climateEnergy?: boolean | undefined;
    co2Mapping?: boolean | undefined;
    energyAdvice?: boolean | undefined;
    climateForest?: boolean | undefined;

    constructor(data?: IGreenOptimizationContractDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.windEnergy = _data["windEnergy"];
            this.climateEnergy = _data["climateEnergy"];
            this.co2Mapping = _data["co2Mapping"];
            this.energyAdvice = _data["energyAdvice"];
            this.climateForest = _data["climateForest"];
        }
    }

    static fromJS(data: any): GreenOptimizationContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new GreenOptimizationContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["windEnergy"] = this.windEnergy;
        data["climateEnergy"] = this.climateEnergy;
        data["co2Mapping"] = this.co2Mapping;
        data["energyAdvice"] = this.energyAdvice;
        data["climateForest"] = this.climateForest;
        super.toJSON(data);
        return data;
    }
}

export interface IGreenOptimizationContractDto extends IModelBase {
    windEnergy?: boolean | undefined;
    climateEnergy?: boolean | undefined;
    co2Mapping?: boolean | undefined;
    energyAdvice?: boolean | undefined;
    climateForest?: boolean | undefined;
}

export class UnitDto implements IUnitDto {
    accountName?: string | undefined;
    connectionid?: string | undefined;
    eanId?: string | undefined;
    street?: string | undefined;
    houseNum?: string | undefined;
    zipcode?: string | undefined;
    city?: string | undefined;
    contractStartDate!: Date;
    contractEndDate!: Date;

    constructor(data?: IUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.connectionid = _data["connectionid"];
            this.eanId = _data["eanId"];
            this.street = _data["street"];
            this.houseNum = _data["houseNum"];
            this.zipcode = _data["zipcode"];
            this.city = _data["city"];
            this.contractStartDate = _data["contractStartDate"] ? new Date(_data["contractStartDate"].toString()) : <any>undefined;
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["connectionid"] = this.connectionid;
        data["eanId"] = this.eanId;
        data["street"] = this.street;
        data["houseNum"] = this.houseNum;
        data["zipcode"] = this.zipcode;
        data["city"] = this.city;
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toISOString() : <any>undefined;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUnitDto {
    accountName?: string | undefined;
    connectionid?: string | undefined;
    eanId?: string | undefined;
    street?: string | undefined;
    houseNum?: string | undefined;
    zipcode?: string | undefined;
    city?: string | undefined;
    contractStartDate: Date;
    contractEndDate: Date;
}

export class MarketingMaterialDto implements IMarketingMaterialDto {
    id!: number;
    marketingMaterialCategory!: MarketingMaterialCategories;
    materialType!: MaterialTypes;
    materialFormat!: MaterialFormats;
    newToUser!: boolean;

    constructor(data?: IMarketingMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.marketingMaterialCategory = _data["marketingMaterialCategory"];
            this.materialType = _data["materialType"];
            this.materialFormat = _data["materialFormat"];
            this.newToUser = _data["newToUser"];
        }
    }

    static fromJS(data: any): MarketingMaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["marketingMaterialCategory"] = this.marketingMaterialCategory;
        data["materialType"] = this.materialType;
        data["materialFormat"] = this.materialFormat;
        data["newToUser"] = this.newToUser;
        return data;
    }
}

export interface IMarketingMaterialDto {
    id: number;
    marketingMaterialCategory: MarketingMaterialCategories;
    materialType: MaterialTypes;
    materialFormat: MaterialFormats;
    newToUser: boolean;
}

export enum MarketingMaterialCategories {
    NotSet = 0,
    WindPower = 1,
    ClimateAction = 2,
    Co2Mapping = 3,
    EnergyConsulting = 4,
    ClimateForest = 5,
}

export enum MaterialTypes {
    NotSet = 0,
    WideBanner = 1,
    SquareBanner = 2,
    WideGroupedBanners = 3,
    SquareGroupedBanners = 4,
    Diploma = 5,
    SoMeTexts = 8,
    CSRTexts = 9,
}

export enum MaterialFormats {
    NotSet = 0,
    PDF = 1,
    JPG = 2,
    PNG = 3,
    Word = 4,
    MP4 = 5,
}

export class News implements INews {
    id?: string | undefined;
    categoryId?: string | undefined;
    authorName?: string | undefined;
    summary?: string | undefined;
    body?: string | undefined;
    headerImageSrc?: string | undefined;
    publishDate!: Date;
    category?: string | undefined;

    constructor(data?: INews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.authorName = _data["authorName"];
            this.summary = _data["summary"];
            this.body = _data["body"];
            this.headerImageSrc = _data["headerImageSrc"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): News {
        data = typeof data === 'object' ? data : {};
        let result = new News();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["authorName"] = this.authorName;
        data["summary"] = this.summary;
        data["body"] = this.body;
        data["headerImageSrc"] = this.headerImageSrc;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["category"] = this.category;
        return data;
    }
}

export interface INews {
    id?: string | undefined;
    categoryId?: string | undefined;
    authorName?: string | undefined;
    summary?: string | undefined;
    body?: string | undefined;
    headerImageSrc?: string | undefined;
    publishDate: Date;
    category?: string | undefined;
}

export class OrganizationDto implements IOrganizationDto {
    organizationId!: number;
    accountNum?: string | undefined;
    accountName?: string | undefined;
    connectionid?: string | undefined;
    street?: string | undefined;
    houseNum?: string | undefined;
    zipcode?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    phonenumber?: string | undefined;
    fax?: string | undefined;
    cvr?: string | undefined;
    homepage?: string | undefined;

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.accountNum = _data["accountNum"];
            this.accountName = _data["accountName"];
            this.connectionid = _data["connectionid"];
            this.street = _data["street"];
            this.houseNum = _data["houseNum"];
            this.zipcode = _data["zipcode"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.phonenumber = _data["phonenumber"];
            this.fax = _data["fax"];
            this.cvr = _data["cvr"];
            this.homepage = _data["homepage"];
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["accountNum"] = this.accountNum;
        data["accountName"] = this.accountName;
        data["connectionid"] = this.connectionid;
        data["street"] = this.street;
        data["houseNum"] = this.houseNum;
        data["zipcode"] = this.zipcode;
        data["city"] = this.city;
        data["email"] = this.email;
        data["phonenumber"] = this.phonenumber;
        data["fax"] = this.fax;
        data["cvr"] = this.cvr;
        data["homepage"] = this.homepage;
        return data;
    }
}

export interface IOrganizationDto {
    organizationId: number;
    accountNum?: string | undefined;
    accountName?: string | undefined;
    connectionid?: string | undefined;
    street?: string | undefined;
    houseNum?: string | undefined;
    zipcode?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    phonenumber?: string | undefined;
    fax?: string | undefined;
    cvr?: string | undefined;
    homepage?: string | undefined;
}

export class StatusMessageDto implements IStatusMessageDto {
    id!: number;
    title?: string | undefined;
    text?: string | undefined;
    date!: Date;

    constructor(data?: IStatusMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StatusMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["text"] = this.text;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStatusMessageDto {
    id: number;
    title?: string | undefined;
    text?: string | undefined;
    date: Date;
}

export class WebHookUserDTO implements IWebHookUserDTO {
    email?: string | undefined;
    authId?: string | undefined;
    name?: string | undefined;
    extension_Role?: string | undefined;

    constructor(data?: IWebHookUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.extension_Role = _data["extension_Role"];
        }
    }

    static fromJS(data: any): WebHookUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebHookUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["extension_Role"] = this.extension_Role;
        return data;
    }
}

export interface IWebHookUserDTO {
    email?: string | undefined;
    authId?: string | undefined;
    name?: string | undefined;
    extension_Role?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

// This class is copied to api.ts when running codegen.